import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Map, Box } from '../../../ui/core';
import { Marker, Polyline } from '@react-google-maps/api';
import mapboxPolyline from '@mapbox/polyline';
import { useSelector } from 'react-redux';
import { getTripRoute } from '../../../redux/Trips/actions';
import { Typography } from '../../../ui/core';

import pickupSvg from '../../../assets/map/pickup.svg';
import dropoffSvg from '../../../assets/map/dropoff.svg';
import driverLastLocationSvg from '../../../assets/map/driver-last-location.svg';
import riderLastLocationSvg from '../../../assets/map/rider-last-location.svg';
import { fetchCurrentLocation } from '../../../redux/Users/actions';

const subPath = (decodedPath, point) => {
  const distances = decodedPath.map((p) => Math.abs(point.lat - p.lat) + Math.abs(point.lng - p.lng));
  const minDistance = Math.min(...distances);
  const minDistanceIdx = distances.indexOf(minDistance);

  return [...decodedPath.slice(0, minDistanceIdx), point];
};

const carIcon = (bearing) => {
  return `data:image/svg+xml,%3Csvg style='transform: rotate(${bearing}deg);' fill='none' xmlns='http://www.w3.org/2000/svg' height='40' width='40' viewBox='6 5 18 40'%3E%3Cg filter='url(%23filter0_d_11114_45907)'%3E%3Cpath d='M22.5113 17.6882C22.5113 17.6882 22.8849 15.1109 22.9942 14.3684C23.104 13.626 23.0831 11.3157 23.0831 11.3157C23.0831 11.3157 22.9125 8.67121 21.5463 7.72424C20.1803 6.7764 22.5113 17.6882 22.5113 17.6882Z' fill='%23262424'%3E%3C/path%3E%3Cpath d='M7.48794 17.6882C7.48794 17.6882 7.11508 15.1109 7.00529 14.3684C6.89548 13.626 6.91594 11.3157 6.91594 11.3157C6.91594 11.3157 7.08712 8.67121 8.45323 7.72424C9.81942 6.7764 7.48794 17.6882 7.48794 17.6882Z' fill='%23262424'%3E%3C/path%3E%3Cpath d='M22.6643 23.4925C22.6643 27.4157 23.4525 31.7731 23.4525 33.7492C23.4525 40.7122 21.5702 42.8297 21.5702 42.8297C21.5702 42.8297 22.6643 19.3284 22.6643 23.4925Z' fill='%23333232'%3E%3C/path%3E%3Cpath d='M7.33205 23.4925C7.33205 27.4157 6.5441 31.7731 6.5441 33.7492C6.5441 40.7122 8.42594 42.8297 8.42594 42.8297C8.42594 42.8297 7.33205 19.3284 7.33205 23.4925Z' fill='%23333232'%3E%3C/path%3E%3Cpath d='M16.4734 5L13.5227 5C9.9216 5 7.00194 7.83897 7.00194 11.3415L7.00194 38.0662C7.00194 39.4479 7.22197 41.5486 8.14284 42.8297C10.2497 45.7624 19.874 45.6843 21.8535 42.8297C22.752 41.5338 22.9942 39.4479 22.9942 38.0662L22.9942 11.3415C22.9942 7.83897 20.0743 5 16.4734 5Z' fill='%233C3838'%3E%3C/path%3E%3Cpath d='M21.8137 42.6844C19.8701 45.4751 10.6484 45.6006 8.31 42.8453C8.28369 42.8636 8.25697 42.8822 8.22817 42.8989C10.4284 45.7594 19.8663 45.6611 21.8203 42.8297C21.8391 42.8026 21.8334 42.7049 21.8137 42.6844Z' fill='%23333232'%3E%3C/path%3E%3Cpath d='M12.3921 43.2029C11.7575 43.2029 10.1897 43.0611 9.34594 41.745C8.51404 40.4487 8.44991 38.4992 8.44991 37.8021L8.4499 10.5233C8.4499 7.47727 10.7525 5.00001 13.5839 5.00001L16.4122 5.00001C19.2432 5.00001 21.5463 7.47727 21.5463 10.5233L21.5463 37.8021C21.5463 38.4992 21.4818 40.4487 20.6502 41.745C19.8067 43.0611 18.2389 43.2029 17.6044 43.2029L12.3921 43.2029Z' fill='url(%23paint0_linear_11114_45907)'%3E%3C/path%3E%3Cpath d='M12.5751 5.1071C12.9708 5.20837 13.9073 5.2795 14.9999 5.2795C16.0911 5.2795 17.0264 5.20837 17.4231 5.10754C17.0959 5.03728 16.7585 4.99998 16.4122 4.99998L13.5839 4.99998C13.2384 4.99998 12.9015 5.03684 12.5751 5.1071Z' fill='%23302F2F'%3E%3C/path%3E%3Cpath d='M22.2695 18.1871L21.9602 18.1175L21.9001 18.4357L22.4245 18.5703L22.2695 18.1871Z' fill='%23100F0D'%3E%3C/path%3E%3Cpath d='M22.1932 18.1019C22.1932 18.1019 23.8909 18.2539 23.9985 19.7207C24.032 19.9228 23.5151 19.7092 23.2875 19.6025C23.06 19.4962 22.1667 19.1502 22.1667 19.1502L22.1932 18.1019Z' fill='%23333232'%3E%3C/path%3E%3Cpath d='M23.8219 19.7957C23.2533 19.2636 22.4117 19.1044 22.1695 19.0684L22.1667 19.1501C22.1667 19.1501 23.06 19.4962 23.2875 19.6025C23.4224 19.666 23.6588 19.7664 23.8219 19.7957Z' fill='%23100F0D'%3E%3C/path%3E%3Cpath d='M7.73051 18.1871L8.03906 18.1175L8.09919 18.4357L7.57478 18.5703L7.73051 18.1871Z' fill='%23100F0D'%3E%3C/path%3E%3Cpath d='M7.80609 18.1019C7.80609 18.1019 6.10862 18.2539 6.00159 19.7207C5.96775 19.9228 6.48406 19.7092 6.71219 19.6025C6.93932 19.4962 7.83264 19.1502 7.83264 19.1502L7.80609 18.1019Z' fill='%23333232'%3E%3C/path%3E%3Cpath d='M6.17761 19.7957C6.74559 19.2636 7.58814 19.1044 7.82989 19.0684L7.83265 19.1501C7.83265 19.1501 6.93933 19.4962 6.7122 19.6025C6.57693 19.666 6.34087 19.7664 6.17761 19.7957Z' fill='%23100F0D'%3E%3C/path%3E%3Cpath d='M20.4826 41.2877C16.8774 42.7265 13.1185 42.7265 9.51308 41.2877C9.72044 39.8523 9.9278 38.4171 10.1352 36.9824C13.3318 38.2581 16.6643 38.2581 19.8605 36.9824C20.0685 38.4171 20.2755 39.8523 20.4826 41.2877Z' fill='%23262424'%3E%3C/path%3E%3Cpath d='M20.9024 23.2748C20.914 24.1723 20.6637 33.0466 20.6637 33.0466L21.1718 37.1422L21.995 37.875L21.9773 17.8656C21.9773 17.8656 20.8907 22.3775 20.9024 23.2748Z' fill='black'%3E%3C/path%3E%3Cpath d='M9.09367 23.2748C9.08191 24.1723 9.33245 33.0466 9.33245 33.0466L8.82411 37.1422L8.00146 37.875L8.01901 17.8656C8.01901 17.8656 9.10585 22.3775 9.09367 23.2748Z' fill='black'%3E%3C/path%3E%3Cpath d='M20.3627 22.0644C18.5461 21.0658 16.8037 20.7214 14.9971 20.7214C13.1906 20.7214 11.3425 21.0658 9.63239 22.0644L9.45112 22.0802L9.41328 21.8959C9.10374 20.3864 8.7739 18.811 8.43087 17.2105L8.42736 17.1936L8.42627 17.1762C8.409 16.9084 8.49917 16.6573 8.69583 16.4303C9.60097 15.3842 12.6856 15.0082 15.0488 15.0082C17.4277 15.0082 20.507 15.3872 21.3462 16.4404C21.5297 16.6705 21.6034 16.9238 21.5664 17.1931C21.218 18.8245 20.8875 20.4001 20.5816 21.8959L20.5442 22.0802L20.3627 22.0644Z' fill='black'%3E%3C/path%3E%3Cpath d='M9.61486 22.0648C9.30789 20.5525 8.98382 18.9951 8.64322 17.3935C8.47855 14.7928 21.7011 14.8119 21.3512 17.3935C21.01 18.9951 20.6866 20.5525 20.3794 22.0648C16.8516 21.0467 13.231 21.1263 9.61486 22.0648Z' fill='black'%3E%3C/path%3E%3Cpath d='M14.9977 41.9408C13.3122 41.9408 11.6247 41.6281 9.9776 41.0115L10.4757 37.5661C11.9594 38.0963 13.4783 38.3648 14.9977 38.3648C16.518 38.3648 18.0369 38.0963 19.5206 37.5661L20.0185 41.0115C18.3714 41.6281 16.6846 41.9408 14.9977 41.9408Z' fill='black'%3E%3C/path%3E%3Cpath d='M14.9998 22.0802C11.7065 22.0802 9.63512 22.9495 9.63512 22.9495L10.1165 37.5373C10.1165 37.5373 11.7621 38.3141 14.9998 38.3141C18.2376 38.3141 19.8832 37.5373 19.8832 37.5373L20.365 22.9495C20.365 22.9495 18.2936 22.0802 14.9998 22.0802Z' fill='url(%23paint1_linear_11114_45907)'%3E%3C/path%3E%3Cpath d='M20.5364 43.0589L20.5709 43.2972L20.8223 43.2104L21.4426 42.9962C21.4864 42.9411 21.5324 42.8869 21.5702 42.8297C21.5702 42.8297 21.7494 42.6278 21.9965 42.1457L20.8742 42.7097L20.5364 43.0589Z' fill='%23DC454A'%3E%3C/path%3E%3Cpath d='M9.46326 43.0589L9.42863 43.2972L9.17766 43.2104L8.55658 42.9962C8.51291 42.9411 8.46699 42.8869 8.42898 42.8297C8.42898 42.8297 8.25004 42.6278 8.00228 42.1457L9.12529 42.7097L9.46326 43.0589Z' fill='%23DC454A'%3E%3C/path%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_11114_45907' x='0' y='-1.52588e-05' width='30' height='52' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'%3E%3C/feFlood%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'%3E%3C/feColorMatrix%3E%3CfeOffset dy='1'%3E%3C/feOffset%3E%3CfeGaussianBlur stdDeviation='3'%3E%3C/feGaussianBlur%3E%3CfeComposite in2='hardAlpha' operator='out'%3E%3C/feComposite%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0'%3E%3C/feColorMatrix%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_11114_45907'%3E%3C/feBlend%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_11114_45907' result='shape'%3E%3C/feBlend%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_11114_45907' x1='14.9981' y1='43.2029' x2='14.9981' y2='9.51412' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23333232'%3E%3C/stop%3E%3Cstop offset='0.700568' stop-color='%23333232'%3E%3C/stop%3E%3Cstop offset='1' stop-color='%23262424'%3E%3C/stop%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_11114_45907' x1='15.0001' y1='38.3141' x2='15.0001' y2='22.0802' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.171875' stop-color='%23262424'%3E%3C/stop%3E%3Cstop offset='0.5' stop-color='%23262424'%3E%3C/stop%3E%3Cstop offset='1' stop-color='%23262424'%3E%3C/stop%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E`;
};

const TripMap = ({ trip }) => {
  const dispatch = useDispatch();

  const isRouteObsolete = useSelector((state) => state.trips.obsoleteTripRoutes[trip.id] === true);
  const tripRoute = useSelector((state) => state.trips.tripRoutes[trip.id]);

  let decodedPath = tripRoute && tripRoute.polyline ? mapboxPolyline.decode(tripRoute.polyline, 6) : [];
  decodedPath = decodedPath.map(([lat, lng]) => ({ lat, lng }));

  const [map, setMap] = useState(null);
  const [center] = useState({ lat: 44, lng: -110 });
  const bounds = [trip.originCity.cityCoord.coordinates, trip.destinationCity.cityCoord.coordinates];

  const driverLocation = useSelector((state) => (trip.driver ? state.drivers.locations[trip.driver.driver_id] : null));
  const driverPosition =
    driverLocation && driverLocation.coordinate
      ? { lat: driverLocation.coordinate.lat, lng: driverLocation.coordinate.lon }
      : null;
  const driverPath = driverPosition ? subPath(decodedPath, driverPosition) : [];

  const lastLocation = useSelector((state) => {
    if (trip.driver) {
      let location = state.users.currentLocations[trip.driver.id] || null;
      return location;
    }
    return null;
  });
  const lastDriverPosition = lastLocation
    ? { lat: lastLocation.coordinate.lat, lng: lastLocation.coordinate.lon }
    : null;
  const lastDriverPositionTime = lastLocation ? new Date(lastLocation.timestamp) : null;

  const riderLastLocations = useSelector((state) => {
    return trip.rides.map((ride) => {
      const riderId = ride.rider.id;
      const riderLocation = state.users.currentLocations[riderId] || null;
      return riderLocation
        ? {
            riderId,
            position: { lat: riderLocation.coordinate.lat, lng: riderLocation.coordinate.lon },
            timestamp: new Date(riderLocation.timestamp),
          }
        : null;
    });
  });

  const onMapLoad = useCallback((map) => setMap(map), []);

  useEffect(() => {
    if (isRouteObsolete) {
      getTripRoute(trip.id)(dispatch);
    }
  }, [isRouteObsolete]);

  useEffect(() => {
    if (map) {
      const mapBounds = new window.google.maps.LatLngBounds();
      mapBounds.extend(new window.google.maps.LatLng(bounds[0][1], bounds[0][0]));
      mapBounds.extend(new window.google.maps.LatLng(bounds[1][1], bounds[1][0]));
      map.fitBounds(mapBounds);
    }
  }, [map]);

  // Polling effect to refresh the driver's last location every 30 seconds
  useEffect(() => {
    if (trip.driver) {
      dispatch(fetchCurrentLocation(trip.driver.id));
      const interval = setInterval(() => {
        dispatch(fetchCurrentLocation(trip.driver.id));
      }, 30000); // 30 seconds
      return () => clearInterval(interval);
    }
  }, [trip.driver, dispatch]);

  useEffect(() => {
    trip.rides.forEach((ride) => {
      if (ride.rider && ride.rider.id) {
        dispatch(fetchCurrentLocation(ride.rider.id));
      }
    });
    const interval = setInterval(() => {
      trip.rides.forEach((ride) => {
        if (ride.rider && ride.rider.id) {
          dispatch(fetchCurrentLocation(ride.rider.id));
        }
      });
    }, 30000); // 30 seconds
    return () => clearInterval(interval);
  }, [trip.rides, dispatch]);

  const points = trip.waypoints.map((w) => {
    const point = w[0];
    return {
      position: { lat: point.coordinates.lat, lng: point.coordinates.lon },
      type: point.type,
    };
  });

  return (
    <Box
      sx={{
        width: 384,
        height: 384,
      }}
    >
      <Map zoom={8} center={center} onLoad={onMapLoad} mapContainerStyle={{ width: 384, height: 384 }}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          zoomControl: true,
          gestureHandling: 'cooperative',
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }]
            },
            {
              featureType: 'transit',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }]
            },
            {
              featureType: 'landscape',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }]
            },
            {
              featureType: 'landscape',
              elementType: 'geometry',
              stylers: [{ color: '#f5f5f5' }]
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [{ color: '#e3f2fd' }]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{ color: '#e0e0e0' }]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [{ color: '#d0d0d0' }]
            }
          ]
        }}
      >
        {points.map((p, idx) => {
          return (
            <Marker key={idx} position={p.position} icon={p.type === 'pick-up' ? pickupSvg : dropoffSvg} zIndex={2} />
          );
        })}
        {driverPosition && (
          <Marker
            position={driverPosition}
            icon={{
              url: carIcon(driverLocation ? driverLocation.bearing : 0),
            }}
            zIndex={1}
          />
        )}
        {!driverPosition && lastDriverPosition && (
          <Marker
            position={lastDriverPosition}
            icon={{ url: driverLastLocationSvg }}
            zIndex={3}
            title={
              lastDriverPositionTime
                ? `${trip.driver.firstName}'s location from ${lastDriverPositionTime.toLocaleString()}`
                : 'No timestamp available'
            }
          />
        )}
        {riderLastLocations.map((riderLocation, idx) => {
          const riderFirstName = trip.rides[idx]?.rider.firstName || 'Rider';
          return (
            riderLocation && (
              <Marker
                key={`rider-${riderLocation.riderId}`}
                position={riderLocation.position}
                icon={{ url: riderLastLocationSvg }}
                zIndex={3}
                title={`${riderFirstName}'s location from ${riderLocation.timestamp.toLocaleString()}`}
              />
            )
          );
        })}
        <Polyline
          key="trip-path"
          path={decodedPath}
          options={{
            strokeColor: '#A9A9A9',
            strokeWeight: 3,
          }}
        />
        <Polyline
          key="driver-path"
          path={driverPath}
          options={{
            strokeColor: '#3E3E3E',
            strokeWeight: 3,
          }}
        />
      </Map>
      {driverPosition ? (
        <Typography color="text.secondary" variant="body2" sx={{ whiteSpace: 'nowrap', marginRight: '8px' }}>
          {`${trip.driver.firstName}'s live location`}
        </Typography>
      ) : lastDriverPositionTime ? (
        <Typography color="text.secondary" variant="body2" sx={{ whiteSpace: 'nowrap', marginRight: '8px' }}>
          {`${trip.driver.firstName}'s location from ${lastDriverPositionTime.toLocaleString()}`}
          <br />
          {lastDriverPosition && points?.[trip.currentWaypoint]?.position ? (
            <Box
              component="a"
              href={`https://www.google.com/maps/dir/${lastDriverPosition.lat},${lastDriverPosition.lng}/${points[trip.currentWaypoint].position.lat},${points[trip.currentWaypoint].position.lng}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'accent.main', textDecoration: 'none' }}
            >
              View ETA in Google Maps
            </Box>
          ) : (
            'ETA link unavailable'
          )}
        </Typography>
      ) : (
        <Typography color="text.secondary" variant="body2" sx={{ whiteSpace: 'nowrap', marginRight: '8px' }}>
          {'No location available'}
        </Typography>
      )}
    </Box>
  );
};

export default ({ trip }) => {
  return <TripMap trip={trip} />;
};
